export const BRAND = {
  name: "Matcha Story",
  tagline: "Crafted Matcha · Desserts · Good Vibes",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/pwbbgit7_ChatGPT%20Image%20May%209%2C%202026%2C%2002_08_08%20PM.png",
};

// Image library — sourced from design_guidelines.json (Unsplash + generated assets)
const IMG = {
  bowl_classic:
    "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/7lbqc1uy_ChatGPT%20Image%20May%2010%2C%202026%2C%2001_30_45%20AM.png",
  strawberry:
    "https://static.prod-images.emergentagent.com/jobs/0695dc8f-e3b1-4476-a0b8-bf692ef7185e/images/5628eda2e1c30e2f156c8e3ee7e4d25c53d4db72347842dff7816b42d5a426d1.png",
  mango:
    "https://static.prod-images.emergentagent.com/jobs/0695dc8f-e3b1-4476-a0b8-bf692ef7185e/images/8a285c5f02225f9ee1c2fc1c8918fa7586f7f561dfb7518e1b297d02d46cdfb2.png",
  cloud:
    "https://images.unsplash.com/photo-1624878534533-e87f7eb43b7a?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  caramel:
    "https://images.unsplash.com/photo-1705720346159-02d8c5aa872b?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  double:
    "https://static.prod-images.emergentagent.com/jobs/0695dc8f-e3b1-4476-a0b8-bf692ef7185e/images/8db65bb1ce1129b8f7d0fe6eaa683df4f593828e91c7d086476a07c0028239ff.png",
  clear:
    "https://static.prod-images.emergentagent.com/jobs/0695dc8f-e3b1-4476-a0b8-bf692ef7185e/images/a86a094145161db85b2b0c65c96f0a3585c8315d0265cda80b3f4c2ad3c27825.png",
  iced_green:
    "https://images.unsplash.com/photo-1536013455804-04eba8a1f3ea?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  jasmine:
    "https://images.unsplash.com/photo-1545518514-ce8448f15bbf?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  earl_grey:
    "https://images.unsplash.com/photo-1515823064-d6e0c04616a7?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  oat:
    "https://images.unsplash.com/photo-1638176067000-9e2741b40df9?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
};

export const MENU_ITEMS = [
  {
    n: "01",
    name: "Basic Matcha Latte",
    description:
      "Smooth, creamy and quietly grounding — our signature ceremonial-grade matcha softened with steamed milk.",
    notes: "Ceremonial · Steamed milk",
    img: IMG.bowl_classic,
  },
  {
    n: "02",
    name: "Matcha Latte Strawberry",
    description:
      "House strawberry compote layered beneath cold milk and a slow pour of stone-ground matcha.",
    notes: "Layered · Cold",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/4ifrma5i_ChatGPT%20Image%20May%2011%2C%202026%2C%2012_27_15%20AM.png",
  },
  {
    n: "03",
    name: "Matcha Latte Mango",
    description:
      "Sun-ripe Alphonso mango folded into milk and bright, vegetal matcha — summer in a glass.",
    notes: "Tropical · Iced",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/i9umkykx_ChatGPT%20Image%20May%2011%2C%202026%2C%2012_18_10%20AM.png",
  },
  {
    n: "04",
    name: "Coconut Matcha Cloud",
    description:
      "Whipped coconut cream rests like a cloud over chilled matcha — gentle, soft, almost floral.",
    notes: "Coconut · Whipped",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/ng4k2n04_ChatGPT%20Image%20May%2011%2C%202026%2C%2012_33_19%20AM.png",
  },
  {
    n: "05",
    name: "Salted Creamcheese Matcha",
    description:
      "House cold-whisked matcha topped with a salted cream-cheese foam and a fine matcha dusting — sweet, salty, silky.",
    notes: "Creamcheese · Sea salt",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/pjuenzo8_ChatGPT%20Image%20May%2010%2C%202026%2C%2003_13_48%20PM.png",
  },
  {
    n: "06",
    name: "Hojicha Latte",
    description:
      "Stone-roasted hojicha drawn long over cold milk and ice — toasty, nutty, gently caramel. The quiet sister of matcha.",
    notes: "Roasted · Iced",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/1y7ivmuu_ChatGPT%20Image%20May%2010%2C%202026%2C%2001_21_36%20AM.png",
  },
  {
    n: "07",
    name: "Salted Creamcheese Hojicha",
    description:
      "Roasted hojicha crowned with a salted cream-cheese foam and a dusting of toasted hojicha — toasty, salty, gently sweet.",
    notes: "Hojicha · Creamcheese",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/1siz0ams_ChatGPT%20Image%20May%2011%2C%202026%2C%2012_18_03%20AM.png",
  },
  {
    n: "08",
    name: "Float Matcha",
    description:
      "Cold matcha topped with a swirl of matcha soft-serve — a slow melt of cream into tea, the way summer should taste.",
    notes: "Soft-serve · Cold",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/6e9y9y54_May%2010%2C%202026%2C%2004_58_00%20PM.png",
  },
  {
    n: "09",
    name: "Hojicha Cloud",
    description:
      "A whipped hojicha cloud floating over clean cold milk, dusted with toasted hojicha — caramel-toasty and quietly sweet.",
    notes: "Whipped · Cold",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/hbr5flkn_ChatGPT%20Image%20May%2011%2C%202026%2C%2001_01_51%20AM.png",
  },
  {
    n: "10",
    name: "Matcha Story Ice-Cream",
    description:
      "Our signature ceremonial-grade matcha churned into a soft, slow-melting swirl — served in our seigaiha-print house tub.",
    notes: "Soft-serve · Cup",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/adtaolsw_ChatGPT%20Image%20May%2016%2C%202026%2C%2011_03_38%20PM.png",
  },
  {
    n: "11",
    name: "Matcha Ice-Cream Latte",
    description:
      "Iced ceremonial matcha latte crowned with a generous scoop of our house matcha ice-cream — a slow, dreamy melt.",
    notes: "Latte · Scoop",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/890i0ly9_ChatGPT%20Image%20May%2016%2C%202026%2C%2010_52_48%20PM.png",
  },
  {
    n: "12",
    name: "Matcha Red Bean",
    description:
      "Iced matcha latte folded with soft-cooked Hokkaido azuki and crowned with whole red beans — earthy sweet, deeply Japanese.",
    notes: "Azuki · Iced",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/c6fzxtaj_ChatGPT%20Image%20May%2017%2C%202026%2C%2011_57_40%20PM.png",
  },
  {
    n: "13",
    name: "Matcha Kinako Cream",
    description:
      "Cold-whisked matcha layered with kinako cream and a generous dusting of roasted soybean powder — toasty, nutty, gentle.",
    notes: "Kinako · Cream",
    img: "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/r0z7nota_ChatGPT%20Image%20May%2017%2C%202026%2C%2011_57_47%20PM.png",
  },
];

export const STORY_IMAGES = {
  hero: IMG.bowl_classic,
  powder:
    "https://images.unsplash.com/photo-1708573106044-2bbefb3d9fc3?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  whisk:
    "https://images.unsplash.com/photo-1755184108643-a8ee184ce542?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  field:
    "https://images.unsplash.com/photo-1582793988951-9aed5509eb97?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  interior:
    "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/nwwzgjlh_Matcha%20.jpg",
  brandSign:
    "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/1pdi6hop_ChatGPT%20Image%20May%209%2C%202026%2C%2002_08_08%20PM.png",
  cupBranded:
    "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/3710egh4_Matcha%20Latte.jpg",
  desserts:
    "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/mnxduf84_ChatGPT%20Image%20May%2010%2C%202026%2C%2001_21_36%20AM.png",
  paperBag:
    "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/5woyrupl_ChatGPT%20Image%20May%2011%2C%202026%2C%2001_14_37%20AM.png",
  menuRef:
    "https://customer-assets.emergentagent.com/job_matcha-cafe-hub/artifacts/puf5buwa_ChatGPT%20Image%20May%209%2C%202026%2C%2002_11_54%20PM.png",
};

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "From the Field",
    body:
      "Single-estate tencha leaves shaded for twenty days beneath bamboo, harvested only at first flush at Marukyu Koyamaen Main Plant.",
  },
  {
    n: "02",
    title: "Stone Ground",
    body:
      "Granite mills turn slow — forty grams an hour — preserving the chlorophyll, the L-theanine, the quiet sweetness.",
  },
  {
    n: "03",
    title: "Whisked to Order",
    body:
      "Each cup is hand-whisked the moment it is ordered. No shortcuts. No syrups masking the leaf.",
  },
];

export const VISIT = {
  address: "12, Jalan Damai Perdana 1/9b, Bandar Damai Perdana",
  city: "56000 Kuala Lumpur, Malaysia",
  hours: [
    { day: "Mon — Fri", time: "11:00 AM — 9:00 PM" },
    { day: "Saturday", time: "11:00 AM — 9:00 PM" },
    { day: "Sunday", time: "11:00 AM — 9:00 PM" },
  ],
  email: "hello@matchastory.my",
  phone: "+60 14-732 6488",
  social: [
    { label: "Instagram", href: "https://instagram.com/matchastorymy", handle: "@matchastorymy" },
    { label: "TikTok", href: "https://tiktok.com/@matchastorymy", handle: "@matchastorymy" },
  ],
};
